import "@esri/calcite-components/dist/components/calcite-button";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "../index.css";
import { useAuth } from "./AuthProvider";

interface ListingProps {
    itemId: string;
    title: string;
    snippet: string;
    licenseExpires?: string;
}

export interface SubProductProps {
    editorsProductId?: string;
    viewersProductId?: string;
}

interface ProductProps {
    listing: ListingProps;
    subProducts: SubProductProps;
}

export default function ProductCard({ listing, subProducts }: ProductProps) {
    // Authentication
    const { token } = useAuth();

    const { t } = useTranslation("common");

    return (
        <>
            <div className="border border-[var(--calcite-color-border-3)] p-6 bg-[var(--calcite-color-foreground-1)] flex flex-col justify-between">
                <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:mt-0 sm:text-left space-y-2">
                        <a
                            className="text-[1.25rem] font-[var(--calcite-font-weight-normal)] text-[var(--calcite-color-text-2)] link-hover-effect"
                            href={`https://marketplace.arcgis.com/listing.html?id=${listing.itemId}`}
                            target="marketplaceWindow"
                        >
                            <>{t(`products.${listing.itemId}`) ?? listing.title}</>
                        </a>
                        <p className="text-sm text-gray-500">{listing.snippet}</p>
                        <p className="text-sm text-gray-500">
                            <>
                                {listing.licenseExpires === "[never expires]"
                                    ? t(`home.neverexpires`)
                                    : t(`home.expiry`, {
                                          expiry: listing.licenseExpires
                                      })}
                            </>
                        </p>
                    </div>
                </div>
                <div className="mt-5 sm:mt-4 sm:flex">
                    <Link
                        to={`/resources/${listing.itemId}?token=${token}`}
                        className="inline-flex w-full justify-center border border-transparent bg-[#0079c1] hover:bg-[#005e95] px-4 py-2 text-base font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:w-auto sm:text-sm"
                    >
                        <>{t("home.download")}</>
                    </Link>
                    <Link
                        to={`/license/${listing.itemId}/${
                            subProducts?.editorsProductId ?? "default"
                        }/${subProducts?.viewersProductId ?? "default"}`}
                        className="mt-3 inline-flex w-full justify-center border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                    >
                        <>{t("home.generate")}</>
                    </Link>
                </div>
            </div>
        </>
    );
}
